import crud from '@/crud/index/index'
import resources from '../../resources'

import computed from './computed'
import data from './data'
import methods from './methods'

export default {
  computed,
  data,
  methods,

  mixins: [crud, resources]
}



// WEBPACK FOOTER //
// ./src/app/professional/agenda/agendas/index/resources/index.js